import { useState } from 'react';
import { ARTIST, CONTACT, LINKS } from '../config';
import { contactImage } from '../photos';
import { ArrowRight, ArrowUpRight } from '../components/Icons';

const CONTACTS = [
  [CONTACT.booking, `mailto:${CONTACT.booking}`],
  ['Instagram', LINKS.instagram],
];

// Like the scatter words, everything on the photo uses mix-blend-difference so it flips
// against whatever is underneath.
const blend = 'text-white mix-blend-difference';

// The fields sit on a dark see-through panel instead of blending, so typing stays readable.
const field =
  'w-full border-0 border-b border-white/40 bg-black/40 px-3 py-2 font-times text-xl text-white outline-none backdrop-blur-sm transition-colors placeholder:text-white/50 focus:border-white focus:bg-black/55';

export default function Contact() {
  const [form, setForm] = useState({ name: '', message: '' });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const send = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Hello from ${form.name || 'the website'}`);
    const body = encodeURIComponent(form.message);
    window.location.href = `mailto:${CONTACT.booking}?subject=${subject}&body=${body}`;
  };

  return (
    <main>
      <h1 className="sr-only">Call me</h1>

      <section className="mx-auto max-w-6xl px-5 pb-24 pt-10 md:px-10 md:pb-32 md:pt-16">
        {/* The contact details span the whole photo, which stretches to fit them if needed. */}
        <div className="relative min-h-[520px] min-w-[300px] overflow-hidden md:aspect-[1280/865] md:min-h-[560px]">
          <img
            src={contactImage}
            alt={ARTIST}
            className="absolute inset-0 h-full w-full object-cover object-[25%_50%] brightness-[0.3] grayscale origin-left scale-[1.2]"
          />

          <div className="relative flex flex-col gap-10 p-5 md:gap-14 md:p-10 lg:p-14">
            <ul className="divide-y divide-white/20 border-b border-white/20">
              {CONTACTS.map(([value, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    target={href.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className={`group grid grid-cols-[1fr_auto] items-baseline gap-4 py-5 ${blend}`}
                  >
                    <span className="break-all font-times text-2xl transition-opacity group-hover:opacity-60 md:text-3xl">
                      {value}
                    </span>
                    <ArrowUpRight className="inline-block self-center text-2xl opacity-60 md:text-3xl transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>

            <form onSubmit={send} className="flex flex-col gap-8">
              <p className={`font-times text-justify text-2xl ${blend}`}>…or leave a message after the tone.</p>
              <input
                value={form.name}
                onChange={set('name')}
                required
                aria-label="Your name"
                placeholder="who's this?"
                className={field}
              />
              <textarea
                rows={4}
                value={form.message}
                onChange={set('message')}
                required
                aria-label="Message"
                placeholder="say something"
                className={`${field} resize-y`}
              />
              <button
                type="submit"
                className="group flex items-center gap-4 self-start bg-bone px-7 py-3.5 font-times text-xl text-black transition-colors hover:bg-oxblood hover:text-bone"
              >
                Send it <ArrowRight className="inline-block text-oxblood transition-transform group-hover:translate-x-1 group-hover:text-mustard" />
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}
